/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" */
import { differenceInDays } from 'date-fns/differenceInDays';
import { parseISO } from 'date-fns/parseISO';
import { v4 as uuidv4 } from 'uuid';

import { TransactionSummary } from '@toucan/client/global/transaction';

export enum QUOTE_DECLINED_REASONS {
    DECIDED_NOT_TO_SELL = 'DECIDED_NOT_TO_SELL',
    ADDED_IN_ERROR = 'ADDED_IN_ERROR',
    NOT_DECLINED = 'NOT_DECLINED',
}

/**
 * Check if the given sku is in the currently active quote
 *
 * @param {string} sku the product sku
 * @param {any} quoteData the quote data
 */
export function isInQuote(sku: string, quoteData: any): boolean {
    if (!quoteData) {
        return false;
    }

    // Check if current sku matches any products in the buy items
    return quoteData.buyValues.some(
        (item: any) => item.data?.product?.sku === sku
    );
}

/**
 * Return a quote item id, ensuring uniqueness in the current iteration
 */
export function getNextQuoteItemId(): string {
    return uuidv4();
}

export function composeQuoteExpiryAsDays(
    transaction: TransactionSummary
): number {
    if (!transaction?.quote?.expiryTime) return 0;

    return differenceInDays(
        parseISO(transaction?.quote?.expiryTime),
        new Date()
    );
}
